<template>
  <div>
    <v-card>
      <v-card-title>Customer Profile</v-card-title>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <div>Account</div>
          <small class="ml-16 text-truncate">{{customerAccount}}</small>
        </div>
        <div class="d-flex justify-space-between">
          <span>Scores</span>
          <small>{{customerScore / (10 ** paymentCoinDecimal)}}</small>
        </div>
        <div class="d-flex justify-space-between">
          <span>Spending</span>
          <small>{{customerSpending / (10 ** paymentCoinDecimal)}}</small>
        </div>
        <v-select
            :items="events"
            outlined
            hide-details
            dense
            color="indigo darken-1"
            class="mt-4"
            v-model="selectedEvent"
        ></v-select>
        <v-data-table
            v-if="selectedEventTable"
            :headers="selectedEventTable.headers"
            :items="selectedEventData"
            :single-expand="true"
            :expanded.sync="selectedEventTable.expanded"
            item-key="transactionHash"
            show-expand
            class="elevation-1 mt-4"
            dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Events</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div class="pa-4">
                <div class="d-flex justify-space-between">
                  <div>Block Height: </div>
                  <div>{{item.blockHeight}}</div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Tx Hash: </div>
                  <div class="text-caption" style="width: 170px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{item.transactionHash}}</div>
                </div>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import backendCall from "@/lib/backendCall";
import ethCall from "@/lib/eth/ethCall";
import config from "@/config";

export default {
  name: "CustomerProfile",
  props: {
    storeAccount: String,
    customerAccount: String
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    selectedEventTable() {
      switch (this.selectedEvent) {
        case "Payment":
          return this.paymentEventTable
        case "Redeem":
          return this.redeemCollectableEventTable
        case "Buy Purchasable":
          return this.buyPurchasableEventTable
      }
      return null
    },
    selectedEventData() {
      const eventDataCopy = this.selectedEventTable.eventData.map(object => Object.assign({}, object))
      for (let i=0; i<eventDataCopy.length; i++) {
        if (this.selectedEvent === "Payment") {
          console.log(eventDataCopy)
          eventDataCopy[i].amount = parseInt(eventDataCopy[i].amount) / (10 ** this.paymentCoinDecimal)
        }
      }
      return eventDataCopy
    }
  },
  data() {
    return {
      customerScore: 0,
      customerSpending: 0,
      events: ["Payment", "Redeem", "Buy Purchasable"],
      selectedEvent: "Payment",
      paymentCoinDecimal: config.commonConfig.paymentCoinDecimal,
      paymentEventTable: {
        expanded: [],
        headers: [
          { text: 'Amount', value: 'amount' },
          { text: 'Timestamp', value: 'timestamp' }
        ],
        eventData: []
      },
      redeemCollectableEventTable: {
        expanded: [],
        headers: [
          { text: 'Collectable Id', value: 'redeemableId' },
          { text: 'Amount', value: 'amount' },
          { text: 'Timestamp', value: 'timestamp' }
        ],
        eventData: []
      },

      buyPurchasableEventTable: {
        expanded: [],
        headers: [
          { text: 'Purchasable Id', value: 'purchasableId' },
          { text: 'Purchasable Amount', value: 'purchasableAmount' },
          { text: 'Timestamp', value: 'timestamp' }
        ],
        eventData: []
      }
    }
  },
  methods: {
    fetchData() {
      this.getCustomerEvents()
      this.getCustomerScore()
      this.getCustomerSpending()
    },
    async getCustomerEvents() {
      try {
        const res = await backendCall.store.getCustomerEvents(this.storeAccount, this.customerAccount)
        if (res.status === 1) {
          const customerEvents = res.data.stores[0]
          this.paymentEventTable.eventData = customerEvents.paymentEvent
          this.buyPurchasableEventTable.eventData = customerEvents.buyPurchasableEvent
          this.redeemCollectableEventTable.eventData = customerEvents.redeemEvent
        }else {
          console.error(res.message)
        }
      }catch (e) {
        console.error(e)
      }
    },
    async getCustomerScore() {
      try {
        this.customerScore = await ethCall.storeFactory.getCustomerRewardScore(this.storeAccount, this.customerAccount)
      }catch (e) {
        console.log(e)
      }
    },
    async getCustomerSpending() {
      try {
        this.customerSpending = await ethCall.storeFactory.getCustomerSpending(this.storeAccount, this.customerAccount)
      }catch (e) {
        console.log(e)
      }

    }
  }
}
</script>

<style scoped>

</style>